import React from "react";

import BioPreview from "./BioPreview";
import LightBox from "./LightBox";

import { fadeIn, setMeta } from "../helpers";

class About extends React.Component {
  constructor(props) {
    super(props);
    this.updateAboutMeta = this.updateAboutMeta.bind(this);

    this.state = {
      bios: [
        {
          name: "Tom Geismar",
          url: "tom",
          bio: (
            <p className="bio">
              Tom Geismar is a founding partner of Chermayeff & Geismar and widely considered a
              pioneer of American graphic design. During the past four decades he has designed more
              than a hundred corporate identity programs. His designs for Xerox, Chase Manhattan
              Bank, Best Products, Gemini Consulting, PBS, Univision, Rockefeller Center and, most
              notably, Mobil Oil have received worldwide acclaim. Tom has also had major
              responsibility for many of the firm’s exhibition designs and world’s fair pavilions.
              His projects include such major tourist attractions as the Ellis Island Immigration
              Museum, the Statue of Liberty Museum, the Truman Presidential Library, and the
              redesigned Star-Spangled Banner exhibition at the Smithsonian National Museum of
              American History. He has received all the major awards in the field, including one of
              the first Presidential Design Awards for helping to establish a national system of
              standardized transportation symbols. In 2014, Tom Geismar received the prestigious
              National Design Award for Lifetime Achievement; he was also awarded an exhibition in
              the School of Visual arts annual Masters Series. <br />
              <br />
              Tom Geismar concurrently attended the Rhode Island School of Design and Brown
              University. A Phi Beta Kappa graduate of Brown, he received a master’s degree in
              graphic design from Yale University, School of Art and Architecture.
            </p>
          ),
        },
        {
          name: "Sagi Haviv",
          url: "sagi",
          bio: (
            <p className="bio">
              Sagi Haviv is a partner and designer at Chermayeff & Geismar & Haviv. He has designed
              over 60 identity programs, including those for the US Open Tennis Championships,
              Conservation International, Harvard University Press, Discovery+, L.A. Reid’s Hitco
              Entertainment, and the U.S. Olympic & Paralympic Museum.
              <br />
              <br />A go-to expert on the process of effective logo design, Sagi contributes
              regularly to Bloomberg Businessweek, PBS, Fast Company, and NBC’s Meet The Press. He
              speaks about logo design around the world, including for TEDx, the AIGA, the HOW
              Design Conference, the Brand New Conference, Princeton University, the Onassis
              Foundation, the American Advertising Federation, and Columbia Business School, amongst
              many others. Sagi has served as Jury Chair for the Clio Awards and the Art Directors
              Club and Jury President for the D&AD Awards.
              <br />
              <br />
              Sagi joined the firm in 2003 after graduating from The Cooper Union School of Art. He
              is coauthor of{" "}
              <em>
                Identify: Basic Principles of Identity Design in the Iconic Trademarks of Chermayeff
                & Geismar
              </em>{" "}
              (Print&nbsp;Publishers, 2011) and <em>Identity: Chermayeff & Geismar & Haviv</em>{" "}
              (Standards Manual, May, 2018). He&nbsp;teaches Visual Identity Design at the School of
              Visual Arts in New York City.
            </p>
          ),
        },
        {
          name: "Mackey Saturday",
          url: "mackey",
          bio: (
            <p className="bio">
              Mackey Saturday is a principal designer at Chermayeff & Geismar & Haviv. Responsible
              for some of today’s most exciting and talked-about
              identities&#8202;&mdash;&#8202;including those for Instagram, Oculus, and
              Luxe&#8202;&mdash;&#8202;Mackey has become a definitive source for trademark design to
              the leading brands of Silicon Valley as well as other progressive companies around the
              world.
              <br />
              <br />
              Mackey joined the firm in 2016 after nearly a decade of running his own studio. He has
              spoken at AIGA events, creative conferences, as well as universities and design
              schools around the country. With a life-long history of pursuing art and visual
              communication, he focuses on idea-driven strategy and graphic design to create and
              advance steadfast identities.
            </p>
          ),
        },
        {
          name: "Melanie McElduff",
          title: "Principal",
          url: "melanie",
          bio: (
            <p className="bio">
              Melanie McElduff is a graphic designer and project manager with over 20 years of
              experience developing and managing brands for a varied and sophisticated clientele.
              <br />
              <br />
              Melanie graduated from with a BFA in Graphic Design from the University of Illinois in
              1998 and joined the firm in 2003. As a designer, brand manager, and creative director,
              she has worked with institutions and companies including Cornell University,
              Middlebury College, Princeton University Press, Hearst Corporation, Library of
              Congress, The Garrison Institute, Satori Software, Vassar College, Lodgeworks,
              Hirshhorn Museum & Sculpture Garden, Archer Hotels, Presto Packaging, Charlie Palmer
              Restaurant Group, and the Brennan Center for Justice at NYU, on tasks ranging from
              identity design and guidelines development, to the design of exhibitions, packaging,
              and print and digital communications.
              <br />
              <br />
              She is a three-time recipient of the Sappi, Ideas that Matter design grant.
            </p>
          ),
        },
      ],
    };
  }

  updateAboutMeta() {
    if (this.props.activeBio === undefined) {
      setMeta("description", document.querySelector(".about--preamble").textContent);
      setMeta(
        "image",
        `${window.location.protocol}//${window.location.hostname}${document
          .querySelector(".about--photos img")
          .getAttribute("src")}`
      );
      setMeta("title", "About - Chermayeff & Geismar & Haviv");
    } else {
      let bioName = this.state.bios.find(x => x.url === this.props.activeBio).name;
      let bioBio = this.state.bios.find(x => x.url === this.props.activeBio).bio;
      let bioImage = `${window.location.protocol}//${window.location.hostname}/img/about-portrait-${
        this.state.bios.find(x => x.url === this.props.activeBio).url
      }.jpg`;

      setMeta("description", bioBio);
      setMeta("image", bioImage);
      setMeta("title", bioName + " - Chermayeff & Geismar & Haviv");
    }
  }

  componentDidMount() {
    fadeIn();
    this.updateAboutMeta();
    this.props.setMaster("pageType", "page");
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.activeBio !== this.props.activeBio) {
      this.updateAboutMeta();
    }
  }

  render() {
    var bioDetails = this.state.bios.find(x => x.url === this.props.activeBio);

    return (
      <section className="content--container js-fade__slow js-fadeMeIn">
        {bioDetails && <LightBox type="bio" details={bioDetails} />}
        <h1 className="about--preamble preamble">
          To ensure the highest level of design, we keep our studio independent and focused, working
          collaboratively from our New York office for our clients around the world. At Chermayeff &
          Geismar & Haviv, every project is met with the creative vision and strategic thinking of
          all the firm’s principals — as well as the diverse abilities, talents, and backgrounds of
          our entire team.
        </h1>
        <section className="about--photos">
          <div className="row">
            <div className="columns columns--6">
              <figure>
                <img
                  src="/img/about-tom-sagi-scott.jpg"
                  srcSet="/img/about-tom-sagi-scott.jpg 1x, /img/about-tom-sagi-scott@2x.jpg 2x"
                  alt="Tom, Sagi, and Scott working"
                />
              </figure>
            </div>
            <div className="columns columns--6">
              <figure>
                <img
                  src="/img/about-working.jpg"
                  srcSet="/img/about-working.jpg 1x, /img/about-working@2x.jpg 2x"
                  alt="The office working on a large guidelines book"
                />
              </figure>
            </div>
          </div>
          <div className="row">
            <div className="columns columns--6">
              <figure>
                <img
                  src="/img/about-group.jpg"
                  srcSet="/img/about-group.jpg 1x, /img/about-group@2x.jpg 2x"
                  alt="The office looking at printouts"
                />
              </figure>
            </div>
            <div className="columns columns--6">
              <figure>
                <img
                  src="/img/about-sagi-marilee.jpg"
                  srcSet="/img/about-sagi-marilee.jpg 1x, /img/about-sagi-marilee@2x.jpg 2x"
                  alt="Sagi and Marilee looking at printouts"
                />
              </figure>
            </div>
          </div>
          <div className="row">
            <div className="columns columns--6">
              <figure>
                <img
                  src="/img/about-tom-sagi-office.jpg"
                  srcSet="/img/about-tom-sagi-office.jpg 1x, /img/about-tom-sagi-office@2x.jpg 2x"
                  alt="Tom and Sagi"
                />
              </figure>
            </div>
            <div className="columns columns--6">
              <figure>
                <img
                  src="/img/about-mist.jpg"
                  srcSet="/img/about-mist.jpg 1x, /img/about-mist@2x.jpg 2x"
                  alt="Mackey, Ivan, Sagi, and Tom"
                />
              </figure>
            </div>
          </div>
        </section>
        <section>
          <div className="row about--longInfo">
            <p>
              Chermayeff & Geismar & Haviv is the brand design firm behind many of the world’s most
              recognizable trademarks. Since 1957, the firm has pioneered the modern movement of
              idea-driven graphic design across every discipline, specializing in brand identities,
              exhibitions, print and motion graphics, and art in architecture.
            </p>
            <p>
              The firm has a global reach, with projects in Europe, Asia, Latin America, and the
              Middle East as well as throughout the United States. It is led by its founding
              partner, designer Tom Geismar, partner and designer Sagi Haviv, and principal
              designers Mackey Saturday and Melanie McElduff.
            </p>
            <p>
              Chermayeff & Geismar & Haviv is known for a collaborative, problem-solving approach to
              design, with personal involvement by all principals in every project and continuous
              attention to the details and nuances of projects as they evolve.
            </p>
          </div>
        </section>
        <section className="about--leadership">
          <div className="row">
            <h1>Leadership</h1>
          </div>
          <div className="row row--inner columns columns--12 columns--12--small about--bioRow">
            <BioPreview details={this.state.bios[0]} />
            <BioPreview details={this.state.bios[1]} />
            <BioPreview details={this.state.bios[2]} />
            <BioPreview details={this.state.bios[3]} />
          </div>
        </section>
      </section>
    );
  }
}

export default About;



/** WEBPACK FOOTER **
 ** ./src/components/About.js
 **/